import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ClientesService } from '../../main/content/clientes/clientes.service';
import { NotificacionesService } from '../notificaciones/notificaciones.service';
import { Cliente } from '../modelos/cliente';

@Component({
  template: `
    <h1 mat-dialog-title>{{ 'FILEMANAGER.LISTADO.CLIENTE' | translate }}</h1>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
    <mat-dialog-content>

    <mat-form-field>
      <mat-select placeholder="{{ 'FILEMANAGER.LISTADO.CLIENTE' | translate }}" formControlName="cliente">
        <mat-option *ngFor="let cliente of clientes" [value]="cliente">{{cliente.nombre}}</mat-option>
      </mat-select>
    </mat-form-field>
      
      </mat-dialog-content>
    <mat-dialog-actions class="fdr">
      <button mat-button type="submit" color="accent" [disabled]="form?.invalid">{{ 'SELECCIONAR' | translate }}</button>
      <!-- <button mat-button type="button" (click)="onNoClick()">Cancelar</button> -->
    </mat-dialog-actions>
  </form>`,

  styles: [`
      .fdr {
        flex-direction: column !important;
      }
  `]
})
export class SelectClientModalComponent implements OnInit {

  clientes: Cliente[];

  clienteSeleccionado: Cliente;

  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<SelectClientModalComponent>,
    private clientesService: ClientesService,
    private notificaciones: NotificacionesService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
      this.getClientes();
   }

  ngOnInit() {
    this.form = this.formBuilder.group({
      cliente: ['', Validators.required]
    });
  }

  submit(form) {
    this.dialogRef.close(form.value.cliente);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getClientes() {
    this.clientesService.getClientes().subscribe(
      data => {
        if (data.success) {
          this.clientes = data.items;
        } else {
          // CONTROLAR ERROR
          this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.SinClientes);
        }
      },
      err => {
        // CONTROLAR ERROR
        this.notificaciones.errorServidor(err.status);
      }
    );

  }

  setCliente(cliente: Cliente) {
    this.clienteSeleccionado = cliente;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/select-client-modal/select-client-modal.component.ts